export class EffectivenessWizardTestStepModel {
    reference: string;
    testMethod: number;
    description: string;
    requiredDocuments: string[];
}
